module.exports = __webpack_public_path__ + "img/wp.189eb20e.svg";